import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const TawkToUiContext = createContext(null);

export function TawkToUiProvider({ children }) {
  const [suppressCount, setSuppressCount] = useState(0);

  const suppressChat = useCallback(() => {
    setSuppressCount((count) => count + 1);
  }, []);

  const unsuppressChat = useCallback(() => {
    setSuppressCount((count) => Math.max(0, count - 1));
  }, []);

  const value = useMemo(
    () => ({ suppressCount, suppressChat, unsuppressChat }),
    [suppressCount, suppressChat, unsuppressChat]
  );

  return <TawkToUiContext.Provider value={value}>{children}</TawkToUiContext.Provider>;
}

export function useTawkToUi() {
  return useContext(TawkToUiContext);
}

/** Hide the tawk.to bubble while `active` (e.g. pitch recording modal open). */
export function useTawkToSuppressWhile(active) {
  const ctx = useTawkToUi();

  useEffect(() => {
    if (!active || !ctx) return undefined;
    ctx.suppressChat();
    return () => ctx.unsuppressChat();
  }, [active, ctx]);
}
